import { styled } from '@mui/material/styles';

import {
  Box,
  Button as Btn,
  TableCell as TableCellStyles,
  Typography,
} from '@mui/material';

export const Container = styled(Box)`
  padding: 42px 30px 42px 30px;
  background: ${({ theme }) => theme.palette.grey[50]};
  width: 100%;
  height: 100%;
  overflow-y: overlay;
`;

export const Filters = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  .container-filters {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }

  .filter-enterprise {
    display: flex;
    border: 1px solid #206da7;
    border-radius: 5px;
    height: 42px;
    color: #206da7;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    text-align: center;
    text-transform: uppercase;
    min-width: 150px;
    width: 150px;
    gap: 5px;
  }

  .filter-board {
    display: flex;
    border: 1px solid #206da7;
    border-radius: 5px;
    width: 130px;
    min-width: 130px;
    height: 42px;
    color: #206da7;
    gap: 5px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    text-align: center;
    text-transform: uppercase;
  }

  .section-filter {
    display: flex;
    gap: 20px;
    width: 100%;
    height: 42px;
    align-items: center;

    .css-cw9yra-MuiInputBase-root-MuiOutlinedInput-root {
      height: 42px;
    }

    .name-filter {
      width: 100%;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      color: #0e0e2c;

      input {
        padding-left: 8px;
      }
    }
  }

  .btn-new-users {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 22px;
    width: 197px;
    height: 48px;
  }
`;
export const Button = styled(Btn)``;

export const Page = styled(Box)`
  margin-top: 20px;
  .container-page {
    display: flex;
    flex-direction: row;
  }
`;
export const SubHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  margin: 0px 20px 20px 20px;

  height: 48px;
  background: #ffffff;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12);

  .members {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 33px;
    gap: 10px;
    border-radius: 0;

    width: 160px;
    height: 48px;

    /* White */

    background: #ffffff;
  }
  .groups {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 33px;
    gap: 10px;
    border-radius: 0;

    width: 160px;
    height: 48px;

    /* White */

    background: #ffffff;
  }
`;

export const Content = styled(Box)`
  .header-guests {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 25px 20px 20px 20px;
    align-items: center;
  }

  .btn-save-guest {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;

    width: 70px;
    height: 36px;
    background: rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    /* .sub-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;

    width: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
      0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12);
  } */
  }
  .input-container {
    height: 42px;
    margin: 0px 20px 20px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

export const Strong = styled(Box)`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #ffffff;
  border-radius: 17px;
`;

export const TableCell = styled(TableCellStyles)`
  .active {
    padding: 4px 12px;
    text-align: center;
    width: 57px;
    height: 28px;
    background: #4caf50;
    border-radius: 50px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: #ffffff;
  }

  .pendent {
    width: 114px;
    height: 28px;
    background: #ffb547;
    border-radius: 50px;
    font-family: 'Roboto';
    font-style: normal;

    line-height: 20px;
    text-align: center;
    letter-spacing: 0.15px;
    color: #ffffff;
    text-align: center;
    display: inline-flex;
    gap: 5px;
    align-items: center;
    justify-content: center;
  }

  .desactive {
    padding: 4px 12px;
    width: 85px;
    height: 28px;
    background: #d62237;
    border-radius: 50px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.15px;
    color: #ffffff;
    text-align: center;
  }

  p {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .css-1ddwgku-MuiButtonBase-root-MuiMenuItem-root {
    padding: 0;
  }

  .css-1poimk-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper {
    box-shadow: none;
    background-color: #ffb400;
  }
`;

export const TitleHeader = styled(Box)``;

export const TableTitle = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.54);
`;

export const Div = styled(Box)`
  h3 {
    padding: 0;
    margin: 0;
    white-space: nowrap;
  }
`;

export const SectionDetails = styled(Box)``;

export const ButtonEdit = styled(Btn)``;
export const MemberDetails = styled(Box)`
  p {
    padding: 0;
    margin: 0;
  }
`;
export const Picture = styled(Box)``;
export const Dropdown = styled(Box)`
  h3 {
    padding: 0;
    margin: 0;
  }
`;

export const Section = styled(Box)`
  margin: 25px 20px 20px 20px;

  .content-Edit {
    border: 1px solid #12094d;
    border-radius: 6px;
    padding: 15px 20px;
  }
  .input {
    width: 100%;
    border: 1px solid #4c4c4c;
    border-radius: 5px;

    height: 54.34px;
  }

  .input-permission {
    width: 100%;
    border: 1px solid #4c4c4c;
    border-radius: 5px;

    height: 54.34px;
    padding: 10px;
  }

  .btn-next {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: end;
  }

  .label {
    padding: 0;
    margin: 0;
  }
`;

export const TextModal = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.54);
`;

export const TitleModal = styled(Typography)`
  width: 391px;
  height: 29px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4caf50;
`;

export const TextModalSuccess = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
  letter-spacing: 0.15px;
  color: #212121;
`;
